import { useEffect, useRef } from "react";
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import AOS from "aos";

import "swiper/css/effect-fade";
import useDeviceType from "../common/useDeviceType";

const Banner = () => {
  const isMobile = useDeviceType();
  const banners = [
    { pc: "/images/banner1.png", mobile: "/images/bannerM1.png" },
    { pc: "/images/banner2.png", mobile: "/images/bannerM2.png" },
    { pc: "/images/banner3.png", mobile: "/images/bannerM3.png" },
  ];
  const swiperRef = useRef<SwiperClass>(null);

  useEffect(() => {
    swiperRef.current?.autoplay?.start();
  }, []);

  return (
    <div className="relative w-full h-full">
      <Swiper
        onSwiper={(swiper: SwiperClass) => (swiperRef.current = swiper)}
        onSlideChangeTransitionStart={async () => {
          await document
            .querySelectorAll<HTMLDivElement>(".bannerTxt")
            .forEach((el) => {
              el.style.display = "none";
            });

          await document
            .querySelectorAll<HTMLDivElement>(".bannerTxt")
            .forEach((el) => {
              el.classList.remove("aos-init");
              el.classList.remove("aos-animate");
            });
        }}
        onSlideChangeTransitionEnd={async () => {
          await document
            .querySelectorAll<HTMLDivElement>(".bannerTxt")
            .forEach((el) => {
              el.style.display = "";
            });
          await AOS.init({ duration: 800 });
        }}
        loop={true}
        loopAdditionalSlides={1}
        slidesPerView={1}
        spaceBetween={30}
        autoplay={{
          delay: 4200,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        }}
        modules={[Autoplay, EffectFade]}
        fadeEffect={{ crossFade: true }}
        className="mySwiper"
      >
        {banners.map((v, i) => (
          <SwiperSlide
            key={i}
            className="relative w-full h-full px-[calc((100%-var(--container))/3)] 3xl:px-[calc((100%-var(--container))/2)]"
          >
            <img
              src={isMobile ? v.mobile : v.pc}
              alt={`싹치워드림 유품정리·특수청소 이벤트 배너 ${i + 1}`}
              className="relative w-full lg:w-auto h-full object-contain 3xl:mx-auto cursor-pointer"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className=" relative w-full h-fit bg-primary py-5 text-white text-center px-[calc((100%-var(--container))/3)] 3xl:px-[calc((100%-var(--container))/2)] ">
        <h4 className="font-medium mb-2.5">
          수도권 전지역!{" "}
          <span className="text-point">(서울 · 경기 · 인천)</span> 언제든지
          문의주시면 싹! 치워드립니다.
        </h4>
        <div className="w-full h-[1px]  bg-white opacity-80"></div>
      </div>
    </div>
  );
};

export default Banner;
